import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import RodeoEventPage from "src/components/events/rodeoEvent/rodeoEventPage";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { APPLICATION_GLOBAL_SLUG, INSIDERODEO_EVENT_STORAGE, RODEO_PAGE_NAME } from "src/_config";
import { APPLICATION_NAME } from "src/_config";
import LandingPage from "src/components/landing/landingPage";

export default function RodeoEventContainer() {
  const userDetails = useAppUserDetailsSelector();
  const gameDetails = useAppGameDetailsSelector();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Events`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    console.log({ gameDetails });
  }, [gameDetails]);

  return (
    <React.Fragment>{gameDetails?.is_show_landing_page == 1 ? <LandingPage /> : <RodeoEventPage />}</React.Fragment>
  );
}
